// @flow
import { getBaseUrl, getClassicBaseUrl } from '../../../redux/modules/config';
import { openDownloadMobileModal, openFeedbackModal, openHealthcheckModal } from '../../../redux/modules/modal';
import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getMobileBrowserOS } from '../../../redux/modules/browser';
import { getWindowSize } from '../../../redux/modules/windowSize';
import LAFooter from './LAFooter';
import { trackClassicLinkClick } from '../../../redux/modules/analytics';

const mapStateToProps = state => {
    const { width: windowWidth } = getWindowSize(state);

    return {
        baseUrl: getBaseUrl(state),
        classicBaseUrl: getClassicBaseUrl(state),
        mobileBrowserOS: getMobileBrowserOS(state),
        windowWidth,
        year: new Date().getFullYear(),
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            openDownloadMobileModal,
            openFeedbackModal,
            openHealthcheckModal,
            trackClassicLinkClick,
        },
        dispatch
    );

type Props = {
    baseUrl: string,
    classicBaseUrl: string,
    mobileBrowserOS: string,
    openDownloadMobileModal: Function,
    openFeedbackModal: Function,
    openHealthcheckModal: Function,
    trackClassicLinkClick: Function,
    windowWidth: number,
    year: number,
};

class LAFooterContainer extends PureComponent<Props> {
    render() {
        const { baseUrl, classicBaseUrl, mobileBrowserOS, windowWidth, year } = this.props;

        return (
            <LAFooter
                baseUrl={baseUrl}
                classicBaseUrl={classicBaseUrl}
                mobileBrowserOS={mobileBrowserOS}
                openDownloadMobileModal={this.props.openDownloadMobileModal}
                openFeedbackModal={this.props.openFeedbackModal}
                openHealthcheckModal={this.props.openHealthcheckModal}
                trackClassicLinkClick={this.props.trackClassicLinkClick}
                windowWidth={windowWidth}
                year={year}
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LAFooterContainer);
